export const COMMITTEE_TITLE = 'Our Committee';

export const COMMITTEE_INTRO = 'Meet the driving force behind our running club. '
  + 'Comprising dedicated individuals passionate about promoting fitness, camaraderie, and a love for running, '
  + 'our committee members drive the vision and initiatives that make our club thrive. '
  + 'From organizing exhilarating events to ensuring seamless operations, '
  + 'each member brings unique skills and expertise to the table. '
  + 'Together, we run towards a healthier, stronger, and more connected future.';
